<div *ngIf="card_wrap; else personDetails" class="card mt-3">
  <div class="card-body">
    <ng-container [ngTemplateOutlet]="personDetails" />
  </div>
</div>

<ng-template #personDetails>
  <div class="row flex-column g-2">
    <div class="col">
      <div class="row align-items-start g-2">
        <div class="col-11">
          <span class="fw-normal pe-2">
            {{ person.person_name }}
            {{ person.employee_id ? '(' + person.employee_id + ')' : '' }}
          </span>

          <span>
            <ts-status-badge
              [status]="person.status ? 'active' : 'inactive'"
              [status_display_name]="person.status_display_name!"
            />
          </span>
        </div>

        <div *ngIf="clear_enabled" class="col-1 d-flex justify-content-end">
          <button
            class="btn-close"
            type="button"
            aria-label="Close"
            (click)="clearPerson()"
          ></button>
        </div>
      </div>
    </div>

    <div class="col d-flex">
      <span class="fst-italic">{{ person.email }}</span>
      <ts-copy [text]="person.email" />
    </div>
  </div>

  <hr />

  <div class="row flex-column g-2">
    <div *ngIf="person?.country_location" class="col">
      <span class="fw-normal pe-1">{{ 'country_location' | translate }}: </span>
      {{ person.country_location }}
    </div>

    <div *ngIf="person?.group_name" class="col">
      <span class="fw-normal pe-1">{{ 'group_name' | translate }}: </span>
      {{ person.group_name }}
    </div>

    <div *ngIf="person?.supervisor" class="col">
      <span class="fw-normal pe-1">{{ 'supervisor' | translate }}: </span>
      {{ person.supervisor }}
    </div>

    <div *ngIf="person?.cost_center" class="col">
      <span class="fw-normal pe-1">{{ 'cost_center' | translate }}: </span>
      {{ person.cost_center }}
    </div>
  </div>
</ng-template>
